// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconExternalLink.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconExternalLink = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 12 12" fill="currentColor" { ...props }>
    <path d="M3 0H3.75V8.25H12V9C12 9.41475 11.664 9.75 11.25 9.75H3C2.58527 9.75 2.25 9.41475 2.25 9V0.75C2.25 0.336001 2.58527 0 3 0Z" />
    <path d="M0.75 12H9C9.414 12 9.75 11.6648 9.75 11.25V10.5H1.5V2.25H0.75C0.335266 2.25 0 2.586 0 3V11.25C0 11.6648 0.335266 12 0.75 12Z" />
    <path d="M11.1709 0C11.3981 0 11.6017 0.101123 11.7393 0.260828C11.8989 0.398292 12 0.601888 12 0.829136V6.75043C12 7.1644 11.6644 7.5 11.2504 7.5C10.8364 7.5 10.5009 7.1644 10.5009 6.75043V2.48313L6.46198 6.52196C6.16937 6.81469 5.69476 6.81469 5.40198 6.52197C5.10919 6.22924 5.10919 5.75464 5.40198 5.46191L9.36493 1.49914H5.24963C4.83563 1.49914 4.5 1.16355 4.5 0.749571C4.5 0.335595 4.83563 0 5.24963 0H11.1709Z" />
  </BaseIcon>
);

export default IconExternalLink;
